<template>
    <tr
        v-if="video"
        class="editable"
    >
        <td>Video agency:</td>
        <td>
            <div class="editable-meta">
                <span
                    v-safe-html="video.metadata.agency"
                    class="editable-content"
                    @dblclick="openEditor()"
                />
                <metadata-field-editor
                    v-if="canEdit"
                    :key="'projectNumber-' + video.id"
                    ref="editableAgency"
                    v-model="video.metadata.agency"
                    name="videoAgency"
                    type="inline"
                    :meta="{counter: 100, pattern: /^([a-zA-Z0-9 \-_\.])+$/gi}"
                    @input="videoAgencyUpdated"
                />
            </div>
        </td>
    </tr>
</template>

<script>
    import updateMeta from '../../../../services/metadata';
    import MetadataFieldEditor from '../editor/MetadataFieldEditor';
    import Gate from '../../../../services/gate';
    import store from '../../../../store/index';

    export default {
        name: 'MetaAgencyField',
        components: {MetadataFieldEditor},
        props: ['video'],
        computed: {
            canEdit() {
                return Gate.allows(store.getters['auth/user'], 'manageVideo', this.video.library);
            }
        },
        methods: {
            videoAgencyUpdated(value) {
                updateMeta(this.video.id, {
                    'agency': value
                });
            },
            openEditor() {
                if(this.canEdit) {
                    this.$refs.editableAgency.openEditor();
                }
            }
        },
    };
</script>

<style scoped>

</style>
